
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default.js';
import type { Item, UI, UIFramework } from 'photoswipe';
import PhotoSwipeFn from 'photoswipe';
import { onBeforeUnmount, shallowRef, watch } from '@vue/composition-api';
interface Props {
  isOpen: boolean;
  items: Item[];
  options: {
    index: number;
  };
}
const __sfc_main = {};
__sfc_main.props = {
  isOpen: {
    key: "isOpen",
    required: true,
    type: Boolean
  },
  items: {
    key: "items",
    required: true,
    type: Array
  },
  options: {
    key: "options",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const events = ['beforeChange', 'afterChange', 'imageLoadComplete', 'resize', 'gettingData', 'mouseUsed', 'initialZoomIn', 'initialZoomInEnd', 'initialZoomOut', 'initialZoomOutEnd', 'parseVerticalMargin', 'close', 'unbindEvents', 'destroy', 'updateScrollOffset', 'preventDragEvent', 'shareLinkClick'];
  let pswp: (UI<{
    index: number;
  }> & UIFramework) | undefined;
  const rootEl = shallowRef<HTMLElement>();
  watch(() => props.isOpen, val => {
    val ? open() : close();
  });
  onBeforeUnmount(() => close());
  function open() {
    if (rootEl.value) {
      pswp = new PhotoSwipeFn(rootEl.value, PhotoSwipeUIDefault, props.items, props.options);
      events.forEach(e => {
        if (pswp) {
          pswp.listen(e, (...args: unknown[]) => {
            args.unshift(rootEl.value);
            emit(e, pswp);
          });
        }
      });
      pswp.init();

      // функция open вызывается только на клиенте, поэтому обращение к document.body - это ок
      document.body.append((rootEl.value as Node));
    }
  }
  function close() {
    if (pswp) {
      pswp?.close();
      pswp = undefined;
    }
  }
  return {
    rootEl
  };
};
export default __sfc_main;
